import { render, staticRenderFns } from "./ImportReportList.vue?vue&type=template&id=5387537b&scoped=true&lang=html&"
import script from "./ImportReportList.vue?vue&type=script&lang=js&"
export * from "./ImportReportList.vue?vue&type=script&lang=js&"
import style0 from "./ImportReportList.vue?vue&type=style&index=0&id=5387537b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387537b",
  null
  
)

component.options.__file = "ImportReportList.vue"
export default component.exports